/**
 * StoneTotem — compact rotating stone, meant to sit next to a user avatar
 * as a symbolic totem of their YUO type. Defaults to a small 44px canvas.
 */
import { Canvas } from "@react-three/fiber";
import { RoundedBox, Float } from "@react-three/drei";
import { Suspense } from "react";

function Rock({ color }) {
  return (
    <Float speed={1.6} rotationIntensity={1.1} floatIntensity={0.4}>
      <RoundedBox args={[1.4, 1.4, 1.4]} radius={0.42} smoothness={6}>
        <meshPhysicalMaterial
          color={color}
          metalness={0.4}
          roughness={0.25}
          clearcoat={0.9}
          clearcoatRoughness={0.15}
          reflectivity={0.6}
        />
      </RoundedBox>
    </Float>
  );
}

export default function StoneTotem({ color = "#A066FF", size = 44, title }) {
  return (
    <div
      data-testid="stone-totem"
      title={title}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        background: `radial-gradient(circle at 50% 40%, ${color}22, transparent 70%)`,
        boxShadow: `0 0 14px -3px ${color}88`,
        flexShrink: 0,
      }}
    >
      <Canvas
        camera={{ position: [0, 0, 3.4], fov: 42 }}
        dpr={[1, 2]}
        gl={{ antialias: true, alpha: true }}
      >
        <ambientLight intensity={0.55} />
        <pointLight position={[2, 2, 2]} intensity={1.4} color={color} />
        <pointLight position={[-2, -2, 2]} intensity={0.7} color="#ffffff" />
        <Suspense fallback={null}>
          <Rock color={color} />
        </Suspense>
      </Canvas>
    </div>
  );
}
